import { ButtonHTMLAttributes, FC, ReactNode, forwardRef } from "react";
import { cn } from "../utils/utils";
import Spinner from "./Spinner";
import usePermission from "src/hooks/usePermission";
import ButtonSkeleton from "src/components/ui/button-skeleton.component";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  children?: ReactNode;
  onClick?: (event: React.MouseEvent) => void;
  isLoading?: boolean;
  loaderSize?: "small" | "medium";
  module?: string;
  action?: string;
}

const Button: FC<ButtonProps> = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ type, className, children, isLoading, loaderSize, module, action, ...rest }, ref) => {
    const { hasPermission, loading } = usePermission({
      module: module || "",
      action: action || "",
    });
    const typeOfButton = type || "button";

    if (loading) return <ButtonSkeleton />;

    if (!hasPermission && module && action) return null;

  return (
    <button
      ref={ref}
      type={typeOfButton}
      disabled={isLoading}
      className={cn(`  py-2 px-3   font-semibold rounded-lg text-sm focus:outline-none inline-flex justify-center items-center ${className}`)}
      {...rest}
    >
      {isLoading && <Spinner size={loaderSize} />} {children}
    </button>
  );
});

export default Button;
